// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__XCKd2","tooltiptext":"tooltip_tooltiptext__VisQI"};